import React from 'react'
import { Link } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const DropdownMenu = () => {
    const projects = [
        {
            name: "Stony Brook Election Visualizer",
            description: "Interactive election results visualization",
            link: "https://sbu-elections.netlify.app",
            external: true,
            icon: "📊"
        },
        {
            name: "Political election statewide simulator",
            description: "Political election statewide simulator",
            link: "https://simulator.nicholasgitman.com",
            external: true,
            icon: "🗳️"
        }
    ];

    return (
        <div className="absolute top-full mt-2 right-0 bg-white rounded-xl shadow-xl border border-slate-200 overflow-hidden animate-fade-in min-w-[320px]">
            <div className="p-2">
                {projects.map((project, idx) => (
                    <Link
                        key={idx}
                        to={project.link}
                        target={project.external ? "_blank" : undefined}
                        rel={project.external ? "noopener noreferrer" : undefined}
                        className="block"
                    >
                        <div className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-50 transition-all duration-200 group">
                            <div className="text-2xl mt-0.5">{project.icon}</div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2">
                                    <h3 className="font-semibold text-slate-900 group-hover:text-blue-600 transition-colors duration-200 normal-case">
                                        {project.name}
                                    </h3>
                                    {project.external && (
                                        <OpenInNewIcon sx={{ fontSize: 14, color: '#94a3b8' }} />
                                    )}
                                </div>
                                <p className="text-sm text-slate-600 mt-0.5 normal-case">
                                    {project.description}
                                </p>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default DropdownMenu